import { Component, inject, signal } from "@angular/core";

import { LanguageService } from "@intocare/language";
import { SUPPORTED_LANGUAGES } from "@intocare/organisation/data";

@Component({
	selector: "ic-change-language",
	templateUrl: "./change-language.component.html",
	styleUrls: ["./change-language.component.scss"],
	standalone: false,
})
export class ChangeLanguageComponent {
	private readonly languageService = inject(LanguageService);

	protected languages = signal(SUPPORTED_LANGUAGES);
	protected language = this.languageService.language;

	protected setLanguage(language: string) {
		this.languageService.setLanguage(language);
	}
}
